import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PrivacyPoliciesVersion, PrivacyPoliciesVersionsState } from './types'

const initialState: PrivacyPoliciesVersionsState = {
  current: null,
  list: [],
  isLoaded: false,
}

export const slice = createSlice({
  name: 'privacyPoliciesVersions',
  initialState,
  reducers: {
    showLoader: (state) => {
      state.isLoaded = false
    },
    hideLoader: (state) => {
      state.isLoaded = true
    },
    setList: (state, action: PayloadAction<PrivacyPoliciesVersion[]>) => {
      state.list = action.payload
    },
    setCurrent: (state, action: PayloadAction<PrivacyPoliciesVersion>) => {
      state.current = action.payload
    },
  },
})

export const { setCurrent, showLoader, hideLoader, setList } = slice.actions

export default slice.reducer
